import script from "./DuplicateReg.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateReg.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateReg.vue?vue&type=style&index=0&id=2fd03153&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fd03153"]])

export default __exports__